import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import {
  getContextInstance,
  getContextInstanceThirdParty,
  saveContextInstanceThirdparty,
} from '../../../services/edge/ContexteService';
import {Context} from "../../../states/Store";
import i18next from "i18next";
import ROUTES from "../../../config/Routes";
import {useHistory} from "react-router-dom";
import {useQuery} from "../../../config/Config";
import EAFormStepper from "../../../components/common/EAFormStepper";
import ProgressInfos from "./ProgressInfos";
import {FormProvider, useForm} from "react-hook-form";
import {useAlert} from "../../../components/common/hooks/useAlert";
import ThirdPartySearch from '../AddContext/components/ThirdPartySearch';
import ThirdPartyList from '../AddContext/components/ThirdPartyList';
import Add from '../AddContext/components/Add';

const defaultValues = {
  tpInfos: null,
  thirdPartyId: null,
  contextInstanceId: null,
  parentId: -1,
  tiersAttributes: [],
  referents: []
};

const AddThirdParty = () => {
  const history = useHistory();
  const stepSetterRef = useRef();
  const [state, dispatch] = useContext(Context);
  const contextInstanceId = parseInt(useQuery().get('instance'));
  const startPoint = parseInt(useQuery().get('start') ?? '-1');
  const [selectedContext, setSelectedContext] = useState();
  const [foundTp, setFoundTp] = useState(null);
  const [addedTpList, setAddedTpList] = useState([]);
  const [existingAssosciated, setExistingAssociated] = useState([]);
  const {onSuccess} = useAlert();

  const formMethods = useForm({
    mode: "onChange",
    delayError: 500,
    defaultValues: {
      ...defaultValues,
      parentId: startPoint || -1,
    },
  });

  const getStepSetter = (setter) => {
    stepSetterRef.current = setter;
  };

  const {setValue, watch, getValues, reset} = formMethods;
  const tiersAttributes = watch("tiersAttributes");
  const tpToAdd = watch("tpInfos");
  const referents = watch("referents");

  useEffect(() => {
    return () => {
      dispatch({type: "IS_ASSOCIATING_CONTEXT_THIRDPARTY", isAssociatingContextThirdParty: false});
    }
  }, [dispatch])

  const fetchContextInstance = useCallback(async () => {
    try {
      const instance = await getContextInstance(state.account.id, Number(contextInstanceId));
      setSelectedContext(instance);
      setValue("contextInstanceId", instance.id);
      setValue("tiersAttributes", instance.tiersAttributes);
      defaultValues.tiersAttributes = instance.tiersAttributes;
      defaultValues.contextInstanceId = instance.id;
      dispatch({type: "IS_ASSOCIATING_CONTEXT_THIRDPARTY", isAssociatingContextThirdParty: true});

      const existingAssociated = await getContextInstanceThirdParty(state.account.id, Number(contextInstanceId), dispatch);
      setExistingAssociated(existingAssociated);
    } catch (e) {
      setSelectedContext(null);
    }
  }, [state.account, contextInstanceId, dispatch, setValue]);

  const onClose = useCallback(() => {
    history.replace(`/${state.account.id}/${ROUTES.CONTEXT}?instance=${selectedContext.id}`);
  }, [history, selectedContext, state.account.id]);

  const saveTiers = useCallback(async () => {
    const payload = addedTpList.map(({ tpInfos, ...payloadInfos }) => payloadInfos)
    await saveContextInstanceThirdparty(
      state.account.id,
      payload,
      dispatch);
    onSuccess(i18next.t("context.notifications.associated"))
    onClose();
  }, [addedTpList, onSuccess, onClose, state.account.id, dispatch])

  const editTp = async (tpToAdd) => {
    setValue("thirdPartyId", tpToAdd.thirdpartyId);
    setValue("tpInfos", tpToAdd);
    stepSetterRef.current(1);
  }

  useEffect(() => {
    fetchContextInstance();
  }, [fetchContextInstance])

  const onEditAttribute = (data, attributeValue) => {
    const tiersAttributes = getValues("tiersAttributes");
    setValue("tiersAttributes", [
      ...tiersAttributes.map((att) => {
        if (att.attributeId === attributeValue.attributeId) {
          return {...att, ...data}
        }
        return att
      })
    ]);
  }

  const addContact = (email) => {
    if(email.trim() === '') return
    const referents = getValues("referents");
    setValue("referents", [...new Set([...referents, email.trim()])]);
  }

  const deleteReferent = (email) => {
    const referents = getValues("referents");
    setValue("referents", referents.filter((r) => r!==email));
  }


  const stepsContent = [
    {
      id: 'search',
      name: 'search',
      left: <ProgressInfos
        context={selectedContext}
        tpList={addedTpList}
        saveTiers={saveTiers}
      />,
      right: <>
        <ThirdPartySearch setFoundTp={setFoundTp}/>
        {foundTp&&<ThirdPartyList
          thirdPartyList={foundTp}
          editTp={editTp}
          addedTpList={addedTpList}
          existingAssosciated={existingAssosciated}
          startPoint={startPoint}
        />}
      </>,
      hideNextButton: true
    },
    {
      id: 'add',
      name: 'add',
      left: <ProgressInfos
        context={selectedContext}
        tpList={addedTpList}
        saveTiers={saveTiers}
      />,
      right: <Add
        tiersAttributes={tiersAttributes}
        tpToAdd={tpToAdd}
        onEditAttribute={onEditAttribute}
        addContact={addContact}
        deleteReferent={deleteReferent}
        referents={referents}
      />
    }
  ];

  const addTiers = useCallback(() => {
    setAddedTpList((prev) => [...prev, getValues()]);
    stepSetterRef.current(0);
    reset({
      ...defaultValues,
      parentId: startPoint || -1,
    });
  }, [getValues, reset, startPoint])




  const onNext = () => {
    //console.log("NEXT")
  }

  return <>
    {selectedContext ? <FormProvider {...formMethods}>
      <EAFormStepper
        stepsContent={stepsContent}
        onClose={onClose}
        onNext={onNext}
        checkValidStep={() => true}
        onSubmit={addTiers}
        finalStepText={i18next.t("context.addTiers.addTiers")}
        isBreadCrumb={false}
        getStepSetter={getStepSetter}
      />
    </FormProvider> : <></>}
  </>
}

export default AddThirdParty;